var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-banner-bottom"},[_vm._m(0),_c('wj-button',{attrs:{"type":"primary"},on:{"click":_vm.goToDataAnaly}},[_vm._v("立即使用")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"start-h2-wrap"},[_vm._v(" 免费专业的SPSSPRO"),_c('br'),_vm._v(" 让数据分析更简单 ")])
}]

export { render, staticRenderFns }